import { Avatar, InitialsAvatar } from '@/components/ui/Avatar';
import { cn } from '@/lib/utils';

import type { WikiPerson } from '../people-wiki.types';

/** The picture of a person, or their initials, in a round chip. `sizeClassName` is the size of the chip. */
export const PersonAvatar = ({
  person,
  sizeClassName,
}: {
  person: Pick<WikiPerson, 'id' | 'name' | 'avatarUrl' | 'primaryEmail'>;
  sizeClassName: string;
}) => (
  <Avatar
    avatarUrl={person.avatarUrl}
    alt={person.name}
    containerClassName={cn('flex shrink-0', sizeClassName)}
    fallback={
      <InitialsAvatar
        name={person.name}
        seed={person.primaryEmail ?? person.id}
        className={sizeClassName}
      />
    }
  />
);
